import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from "../../../shared/services/session.service";
import { AlertPopupService } from "../../../shared/services/alert-popup.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { CustomerDoRegister } from "../../../states/auth/auth.actions";
import { RegexEnum } from "../../../core/enums/regex.enum";
import { Location } from "@angular/common";

@Component({
	selector: 'app-login',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
	// get selectedTab(): string {
	// 	return this._selectedTab;
	// }
	// set selectedTab(value: string) {
	// 	this._selectedTab = value;
	// }
	// private _selectedTab = 'email';
	public form: FormGroup;
	// public form1: FormGroup;
	private _termAndConditionBlock: boolean = false;
	get termAndConditionBlock(): boolean {
		return this._termAndConditionBlock;
	}
	set termAndConditionBlock(value: boolean) {
		this._termAndConditionBlock = value;
	}

	constructor(
		private sessionService: SessionService,
		private alertPopupService: AlertPopupService,
		private router: Router,
		private formBuilder: FormBuilder,
		private store: Store,
		private location: Location
	) {
	}

	ngOnInit(): void {
		this.subscribeToSession();
		this.initializeForm();
	}

	subscribeToSession() {
		if (this.sessionService.state?.profile) {
			this.router.navigate(['']);
			this.alertPopupService.showWarningAlert('You already have an active session!!!');
		}
	}

	initializeForm(): void {
		this.form = this.formBuilder.group({
			title: ['Mr', [Validators.required]],
			firstName: ['', [Validators.required]],
			lastName: ['', [Validators.required]],
			emailId: ['', [Validators.email]],
			// mobile: ['', [Validators.required, Validators.pattern(RegexEnum.PhoneNumberRegexWithCode)]],
			mobile: ['', [Validators.required, Validators.pattern(RegexEnum.Numeric), Validators.minLength(10), Validators.maxLength(10)]],
			password: ['', [Validators.pattern(RegexEnum.PasswordRegex)]],
			tnc: [false, []],
			// subscribeToNewsletter: [true, []],
			//whatsAppUpdates: [true, []],
		});

		// this.form.get('emailId')?.valueChanges.subscribe((value) => {
		// 	const passwordControl = this.form.get('password');
		// 	if (value.trim() !== '') {
		// 		passwordControl?.setValidators([Validators.required, Validators.pattern(RegexEnum.PasswordRegex)]);
		// 	} else {
		// 		passwordControl?.clearValidators();
		// 	}
		// 	passwordControl?.updateValueAndValidity();
		// });

		// this.form1 = this.formBuilder.group({
		// 	title: ['Mr', [Validators.required]],
		// 	firstName: ['', [Validators.required]],
		// 	lastName: ['', [Validators.required]],
		// 	mobile: ['', [Validators.required, Validators.pattern(RegexEnum.PhoneNumberRegexWithCode)]],
		// 	tnc: [false, []],
		// 	// subscribeToNewsletter: [true, []],
		// 	//whatsAppUpdates: [true, []],
		// });
	}

	markTouchedAndDirty(value: string | boolean, key: string, form: FormGroup): void {
		form.controls[key].markAsTouched();
		if (!value) {
			form.controls[key].markAsDirty();
		}
	}

	onSubmit(form: FormGroup): void {
		try {
			if (!form.value.tnc) {
				throw 'Please check Term and conditions!';
			}

			if (form.valid) {
				let params: any = {
					title: form.value.title,
					firstName: form.value.firstName,
					lastName: form.value.lastName,
					role: "CUSTOMER",
					isFirstTime: true,
					// emailId: form.value.emailId,
					// password: form.value.password,
					mobile: '+91' + form.value.mobile,
				};

				if (form.value.emailId !== "") {
					params = {
						...params,
						emailId: form.value.emailId
					}
				}

				if (form.value.password !== "") {
					params = {
						...params,
						password: form.value.password
					}
				}

				// if (this.selectedTab === 'email') {
				// 	params = {
				// 		...params,
				// 		emailId: form.value.emailId,
				// 		password: form.value.password
				// 	}
				// }

				// if (this.selectedTab === 'mobile') {
				// 	params = {
				// 		...params,
				// 		mobile: form.value.mobile,
				// 	}
				// }

				this.store.dispatch(new CustomerDoRegister(params));
			} else {
				form.markAllAsTouched();
				this.alertPopupService.showWarningAlert('You missed to fill some required fields.');
			}
		} catch (e) {
			this.alertPopupService.showErrorAlert(`${e}`);
		}
	}

	onDeclineClick() {
		this.alertPopupService.showErrorAlert(
			'You are not allowed to signup without accepting the terms and condition'
		);
	}

	get title(): string {
		return !this.termAndConditionBlock ? 'Register with us' : 'Terms & Condition';
	}

	get subtitle(): string {
		return !this.termAndConditionBlock ? 'Fill all details and get registered with Ausmit' : '';
	}

	backBtnClick() {
		this.location.back();
	}
}
